<template>
    <div class="record min-height">
        <div class="flex align-center justify-between">
            <div class="page-title ">{{ company_name }}</div>
            <el-button
                class="margin-left font-size"
                type="primary"
                @click="addItem(false)">+添加记录
            </el-button>
        </div>
        <el-table
            :data="tableData"
            alig="center"
            border
            class="margin-top"
            header-row-class-name="table-header"
            row-class-name="table-row"
            :default-expand-all="true"
            style="width: 100%">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <el-form-item label="支付类型">
                            <span>{{  props.row.pay_type === 1 ? '微信' : '对公' }}</span>
                        </el-form-item>
                        <el-form-item label="微信订单号" v-if="props.row.pay_type === 1">
                            <span>{{  props.row.wx_order_num || '--'}}</span>
                        </el-form-item>
                        <el-form-item label="退款金额" v-if="props.row.refund_order">
                            <span>{{  props.row.refund_order.refund_number }}</span>
                        </el-form-item>
                        <el-form-item label="退款时间" v-if="props.row.refund_order">
                            <span>{{ props.row.refund_order.add_time }}</span>
                        </el-form-item>
                        <el-form-item label="退款原因" v-if="props.row.refund_order">
                            <span>{{ props.row.refund_order.refund_reason }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column label="序号" type="" width="80">
                <template slot-scope="scope">
                    {{ (page - 1) * 10 + scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column label="缴费金额" prop="price"></el-table-column>
            <el-table-column label="缴费时间" prop="add_time"></el-table-column>
<!--            <el-table-column label="有效期开始时间" prop="start_time"></el-table-column>-->
<!--            <el-table-column label="有效期结束时间" prop="end_time"></el-table-column>-->
            <el-table-column label="发票状态">
                <template slot-scope="scope">
                    <el-link v-if="scope.row.invoice_status === 1" :href="scope.row.invoice_url || (showhost + scope.row.invoice_img)" :underline="false" target="_blank">
                        <el-button class="font-size-sm margin-left-sm" type="text">
                            已开立
                        </el-button>
                    </el-link>
                    <el-button v-else class="font-size-sm margin-left-sm" disabled type="text">未开立</el-button>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <div v-if="scope.row.pay_type === 1">
                        <div  v-if="scope.row.pay_status === 1">
                            <el-button class="font-size-sm" type="text" @click="tkItem(scope.row)" >退款</el-button>
                            <el-divider direction="vertical"></el-divider>
                            <el-button class="font-size-sm" type="text" @click="addItem(scope.row)">开票</el-button>
                        </div>
                        <el-button class="font-size-sm" type="text" disabled  v-else>已退款</el-button>
                    </div>
                    <div v-else>
                        <el-button class="font-size-sm" type="text" @click="addItem(scope.row)">编辑</el-button>
                        <el-divider direction="vertical"></el-divider>
                        <el-button class="font-size-sm" type="text" @click="deleteItem(scope.row.id)">删除</el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <div class="flex align-center justify-between padding-top-sm">
            <span>共{{ total }}条数据</span>
            <el-pagination
                v-if="tableData.length > 0"
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                layout="prev, pager, next, jumper"
                @current-change="getList"
            >
            </el-pagination>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :visible.sync="dialog"
            center
            title="缴费记录"
            width="480px">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto">
                <el-form-item label="缴费金额" prop="price">
                    <el-input v-model="ruleForm.price" placeholder="请输入缴费金额" :disabled="ruleForm.isWx">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="缴费时间" prop="add_time">
                    <el-date-picker
                        v-model="ruleForm.add_time"
                        placeholder="请选择缴费时间"
                        style="width: 100%"
                        type="date"
                        value-format="yyyy-MM-dd" :disabled="ruleForm.isWx">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="有效期时间" prop="date" v-if="start_time">
                    <el-date-picker
                        v-model="ruleForm.date"
                        placeholder="请选择有效期结束日期"
                        style="width: 100%"
                        type="date"
                        value-format="yyyy-MM-dd" :disabled="ruleForm.isWx">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="有效期时间" prop="date" v-else>
                    <el-date-picker
                        v-model="ruleForm.date"
                        end-placeholder="结束日期"
                        placeholder="请选择有效期时间"
                        start-placeholder="开始日期"
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd" :disabled="ruleForm.isWx">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="发票状态" required>
                    <el-select v-model="ruleForm.invoice_status" placeholder="请选择" style="width: 100%;">
                        <el-option :value="0" label="未开立"></el-option>
                        <el-option :value="1" label="已开立"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="ruleForm.invoice_status === 1" label="发票链接" prop="invoice_url">
                    <el-input v-model="ruleForm.invoice_url" placeholder="请输入发票链接"></el-input>
                </el-form-item>
                <el-form-item v-if="ruleForm.invoice_status === 1" label="上传文件" prop="invoice">
                    <el-upload
                        ref="upload3"
                        :action="udhost + '/api/index/upload'"
                        :data="fileData"
                        :name="'file'"
                        :on-success="handleAvatarSuccess"
                        :show-file-list="false">
                        <el-button v-if="ruleForm.invoice_img" plain type="primary">已上传</el-button>
                        <el-button v-else plain type="primary"> +点击上传文件</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item v-if="ruleForm.invoice_status === 1">
                    <div class="red">注： 以上两种至少上传一项</div>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm('ruleForm')">取消</el-button>
                    <el-button class="padding-lr-xl" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :visible.sync="tkDialog"
            center
            title="退款"
            width="480px">
            <el-form ref="ruleTkForm" :model="ruleTkForm" :rules="tkRules" label-width="auto">
                <el-form-item label="退款金额" prop="refund_number">
                    <el-input v-model="ruleTkForm.refund_number" placeholder="请输入退款金额">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="退款时间" prop="refund_time">
                    <el-date-picker
                        v-model="ruleTkForm.refund_time"
                        placeholder="请选择退款时间"
                        style="width: 100%"
                        type="date"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="退款原因" prop="refund_reason">
                    <el-input :rows="5" type="textarea" v-model="ruleTkForm.refund_reason" placeholder="请输入退款原因"></el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm('ruleTkForm')">取消</el-button>
                    <el-button class="padding-lr-xl" type="primary" @click="submitTkForm('ruleTkForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {getOrderlist, getTotalMoney} from "@/api/member";
import {SHOWHOST, UDHOST} from "@/config";
import {addOrder, delOrder, updateOrder,refund_order,getCerttime} from "@/api/admin";

export default {
    name: "record",
    data() {
        const validateInvoice = (rule, value, callback) => {
            if (!this.ruleForm.invoice_img && !this.ruleForm.invoice_url) {
                callback(new Error('请上传文件或填写发票链接'));
            } else {
                callback();
            }
        };
        return {
            company_name: '',
            tableData: [],
            page: 1,
            limit: 10,
            total: 0,
            price: 0,
            start_time:'',
            tkDialog:false,
            ruleTkForm: {
                refund_number: '',//	6000	Text	是价格
                refund_reason: '',//	2022-3-29	Date	是缴费时间
                refund_time: '',//	2022-3-29	Date	是缴费时间
            },
            tkRules: {
                refund_number: [{required: true, message: '请输入退款金额', trigger: 'blur'},
                    {
                        pattern: /(^[1-9]([0-9]{1,7})?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
                        message: '请输入正确格式,可保留两位小数,最大值为99999999.99'
                    },
                ],
                refund_time: [{required: true, message: '请选择退款时间', trigger: 'blur'}],
                refund_reason: [{required: true, message: '请输入退款原因', trigger: 'blur'}],
            },
            dialog: false,
            cur_id: 0,
            ruleForm: {
                isWx:false,
                price: '',//	6000	Text	是价格
                add_time: '',//	2022-3-29	Date	是缴费时间
                date: [],	//2	Text	是缴费
                invoice_status: 0,//	-	Text	是证书状态
                invoice_url: '',	//-	Text	是证书地址
                invoice_img: '',	//-	Text	是证书地址
            },
            rules: {
                price: [{required: true, message: '请输入缴费金额', trigger: 'blur'},
                    {
                        pattern: /(^[1-9]([0-9]{1,7})?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
                        message: '请输入正确格式,可保留两位小数,最大值为99999999.99'
                    },
                ],
                add_time: [{required: true, message: '请选择缴费时间', trigger: 'blur'}],
                date: [
                    {required: true, message: '请选择有效期时间', trigger: 'change'}
                ],
                pay_years: [{required: true, message: '请选择缴费年限', trigger: 'blur'}],
                invoice_status: [{required: true, message: '请选择发票状态', trigger: 'blur'}],
                invoice_url: [
                    {
                        pattern: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_+.~#?&=]*)/,
                        message: '请输入正确的地址，必须包含http'
                    }
                ],
                invoice: [{validator: validateInvoice, trigger: 'blur'}],
            },
        }
    },
    computed: {
        udhost() {
            return UDHOST
        },
        showhost() {
            return SHOWHOST
        },
        fileData() {
            return {
                // token: this.user.token
            };
        },
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", '/admin/member', "会员管理  / 缴费信息及发票管理", true, 'icon-yonghu');
        this.company_name = this.$route.params.name
        this.init()
        this.getList()
    },
    components: {},
    methods: {
        async init() {
            let _data = await getTotalMoney(this.$route.params.id)
            this.price = _data.data.price
            _data = await getCerttime(this.$route.params.id)
            this.start_time = _data.data.start_time

        },
        //  获取列表
        async getList() {
            let _list = await getOrderlist(this.$route.params.id, this.page, this.limit)
            this.tableData = _list.data
            this.total = _list.total
        },
        tkItem(data){
            this.cur_id = data.id
            this.tkDialog = true
        },
        submitTkForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitTkData(formName)
                }
            });
        },
        //  审核驳回提交
        async submitTkData() {
            let _state = await refund_order(this.cur_id, this.ruleTkForm.refund_number, this.ruleTkForm.refund_time,
                this.ruleTkForm.refund_reason)
            if (_state.status === 200) {
                this.$message.success('操作成功')
                this.resetForm()
                this.getList()
            } else {
                this.$message.error(_state.msg)
            }
        },
        addItem(data) {
            if (data) {
                this.ruleForm.isWx = data.pay_type === 1
                this.cur_id = data.id
                this.ruleForm.price = data.price
                this.ruleForm.add_time = data.add_time
                this.ruleForm.date =  data.end_time
                this.ruleForm.invoice_status = data.invoice_status
                this.ruleForm.invoice_url = data.invoice_url
                this.ruleForm.invoice_img = data.invoice_img
            } else {
                this.ruleForm.isWx = false
                this.cur_id = 0
                this.ruleForm.price = this.price
                this.ruleForm.add_time = ''
                this.ruleForm.date = this.start_time ? '' :[]
                this.ruleForm.invoice_status = 0
                this.ruleForm.invoice_url = ''
                this.ruleForm.invoice_img = ''
            }
            this.dialog = true
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        //  审核驳回提交
        async submitData() {
            let _state = this.cur_id ? await updateOrder(this.cur_id, this.ruleForm.price, this.ruleForm.add_time,
                    '', this.ruleForm.date, this.ruleForm.invoice_status,
                    this.ruleForm.invoice_status ? this.ruleForm.invoice_url : '',
                    this.ruleForm.invoice_status ? this.ruleForm.invoice_img : '') :
                await addOrder(this.$route.params.id, this.ruleForm.price, this.ruleForm.add_time,
                    this.start_time ? this.start_time : this.ruleForm.date[0],this.start_time ? this.ruleForm.date : this.ruleForm.date[1], this.ruleForm.invoice_status,
                    this.ruleForm.invoice_status ? this.ruleForm.invoice_url : '',
                    this.ruleForm.invoice_status ? this.ruleForm.invoice_img : '')
            if (_state.status === 200) {
                this.$message.success('操作成功')
                this.resetForm()
                this.getList()
            } else {
                this.$message.error(_state.msg)
            }
        },

        //  审核驳回 取消
        resetForm() {
            this.dialog = false
            this.tkDialog = false
        },
        handleAvatarSuccess(res) {
            if (res.status === 200) {
                this.ruleForm.invoice_img = res.url
            } else {
                this.$message.error(res.info)
            }
        },
        //  删除
        deleteItem(id) {
            this.$confirm('此操作将删除选择的会员, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDel(id)
            })
        },
        async sureDel(id) {
            let _state = await delOrder(id)
            if (_state.status === 200) {
                this.$message.success('操作成功')
            } else {
                this.$message.error(_state.msg)
            }
            this.getList()
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>

.record {
    background: #fff;
    padding: 30px;
    border-radius: 8px;

    .page-title {
        font-size: 20px;
        font-weight: bold;
        color: #0d7fd7;
    }
}

.pople-list {
    span {
        display: block;
        width: 80px;
        margin: 0 10px 10px 0;
        font-size: 14px;
    }
}
</style>